/*
    Actions -> Migration
    Actions to get migration data
    We include here differents calls to API to get data for migration

    1. ACTIONS
        - Get migration data actions

    2. CALLS TO API
        - Get migration data
*/

// @utils
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');

// @components
const {
  actionTypes,
  CALL_STATUS,
  DATA_PROTECTION_PATH,
  MIGRATION_STATE,
} = require('../migrationUsersBranchView.constants');

// @actions
const signaturePatternActions = require('actions/signaturePattern');
const { termsKeys } = require('../components/terms/terms.component.poeditor');

// @helpers
const { formatText } = require('core/i18n').i18n;
const { getDocumentLink } = require('../utilities/migration.utils');

import { recordLinkV2 } from 'utilities/tagging';
import { analyticsId, catalogue } from '../components/terms/analytics/terms.tracking';

// ACTIONS
// Get migration actions
const fetchGetMigrationDataProgress = () => ({
  type: actionTypes.FETCH_GET_MIGRATION_DATA_IN_PROGRESS,
});

const fetchGetMigrationDataSuccess = data => ({
  type: actionTypes.FETCH_GET_MIGRATION_DATA_SUCCESS,
  payload: data,
});

const fetchGetMigrationDataFailure = error => ({
  type: actionTypes.FETCH_GET_MIGRATION_DATA_FAILURE,
  payload: { error },
});

// CALLS TO API

// Get migration data
const getMigrationData = () => dispatch => {
  dispatch(fetchGetMigrationDataProgress());
  return APIGet(dispatch, apiURLBuilder.getURL('migrationState'))
    .then(response => {
      dispatch(fetchGetMigrationDataSuccess(response));
      return response;
    })
    .catch(response => {
      dispatch(fetchGetMigrationDataFailure(response.error || response));
    });
};

// Send gp data
const sendGPData = (dispatch, gpData) =>
  APIPost({
    dispatch,
    url: apiURLBuilder.getURL('migrationGenerateDocs'),
    params: { query: gpData },
  });

// sendOtp and call terms and conditions

const verifyOtpPrecontractualConsents = (
  dispatch,
  getState,
  handleSendConsentsStatus,
  optionalConsent,
  operationProcessId
) => {
  const sendPrecontractualConsents = (dispatch, getState, dataToken) => {
    handleSendConsentsStatus(CALL_STATUS.IN_PROGRESS);
    const customerId = getState().profile.getIn([
      'documentoIdentificacion',
      'codigodocumpersonacorp',
    ]);

    const consentData = [
      {
        productId: 'precontractualconsents',
        acceptedText: formatText(termsKeys.contractualInfoCheckboxText),
        notificationId: null,
        customerId: customerId,
        country: 'DE',
        channel: 'WEB',
        agentId: null,
        urlVersion: '0.1',
      },
      {
        productId: 'precontractualconsents',
        acceptedText: formatText(termsKeys.dataProtectionCheckboxText, [
          getDocumentLink(DATA_PROTECTION_PATH),
          formatText(termsKeys.dataProtectionLink),
        ]),
        notificationId: null,
        customerId: customerId,
        country: 'DE',
        channel: 'WEB',
        agentId: null,
        urlVersion: '0.1',
      },
    ];

    if (optionalConsent) {
      consentData.push({
        productId: 'paymentsconsent',
        acceptedText: formatText(termsKeys.optionalConsentCheckboxText),
        notificationId: null,
        customerId: customerId,
        country: 'DE',
        channel: 'WEB',
        agentId: null,
        urlVersion: '0.1',
      });
    }

    const data = {
      query: {
        dataToken,
        data: consentData,
        operationProcessId,
      },
    };

    return APIPost({
      dispatch,
      url: apiURLBuilder.getURL('migrationTerms'),
      params: data,
    })
      .then(() => {
        getMigrationData()(dispatch);
        recordLinkV2(catalogue[analyticsId.SUCCESS_SIGN_CONTRACT]());
      })
      .catch(() => {
        handleSendConsentsStatus(CALL_STATUS.ERROR);
      });
  };

  new Promise(() => {
    signaturePatternActions
      .validateAndExecute(dispatch, getState, sendPrecontractualConsents)
      .catch(() => handleSendConsentsStatus(CALL_STATUS.ERROR));
  });
};

export const getUrlIdentification = dispatch => {
  return APIGet(dispatch, apiURLBuilder.getURL('migrationIdentification'));
};

export const rejectMigration = dispatch => {
  return APIPost(dispatch, apiURLBuilder.getURL('migrationReject'));
};

export const initMigration = dispatch => {
  return APIPost(dispatch, apiURLBuilder.getURL('migrationInitialization'));
};

module.exports = {
  getMigrationData,
  getUrlIdentification,
  sendGPData,
  verifyOtpPrecontractualConsents,
  rejectMigration,
  initMigration,
};
